import React, { useEffect, useState } from "react";
import {
  Modal,
  Row,
  Col,
  Button,
  Typography,
  Space,
  Select,
  Input,
  message,
} from "antd";
import { IoCloseSharp } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import * as selectors from "../selectors";
import { getLogisticListFilters } from "../helpers";
import { actions } from "../slice";
const { Title, Text } = Typography;

function AssignLogisticToKit({
  isAssignLogisticModalVisible,
  setIsAssignLogisticModalVisible,
  KitDetail,
  fetchKitLists,
}) {
  const dispatch = useDispatch();

  const logisticList = useSelector(selectors.selectLogisticList);
  const [selectedLogistic, setSelectedLogistic] = useState(null);
  const [trackingId, setTrackingId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleAddLogistic = () => {
    if (!selectedLogistic && !trackingId) {
      message.warning("At least one field is required.");
      return;
    }
    if (
      selectedLogistic === KitDetail?.assignedLogistic?._id &&
      trackingId === KitDetail?.trackingId
    ) {
      message.warning("No new changes detected.");
      return;
    }

    setIsLoading(true);
    const postData = {
      samplerKitId: KitDetail?._id,
      logisticId: selectedLogistic,
      trackingId: trackingId,
    };
    dispatch(
      actions.assignLogisticToKit({
        postData,
        onSuccess: () => {
          message.success("Logistic Assign Successfully");
          fetchKitLists();
          resetState();
        },
        onFailure: () => {
          setIsLoading(false);
          message.error("Failed to assign Logistic");
        },
      })
    );
  };

  const resetState = () => {
    setSelectedLogistic(null);
    setTrackingId(null);
    setIsAssignLogisticModalVisible(false);
    setIsLoading(false);
  };

  useEffect(() => {
    if (KitDetail?.assignedLogistic?._id) {
      setSelectedLogistic(KitDetail?.assignedLogistic?._id);
    }
    if (KitDetail?.trackingId) {
      setTrackingId(KitDetail?.trackingId);
    }
  }, [KitDetail?.assignedLogistic, KitDetail?.trackingId]);

  return (
    <Modal
      visible={isAssignLogisticModalVisible}
      onCancel={resetState}
      footer={null}
      width={600}
      bodyStyle={{
        borderRadius: 16,
        padding: 24,
        background: "#fff",
      }}
      style={{ borderRadius: 16 }}
      closeIcon={<IoCloseSharp size="24" />}
      centered
      className="modal-content"
    >
      <Title level={3} style={{ fontWeight: 800, marginBottom: 20 }}>
        Add Logistic
      </Title>
      <div>
        <Row gutter={[0, 12]}>
          <Col span={24}>
            <Text style={{ fontWeight: 600, color: "#232A36" }}>Logistic</Text>
            <Select
              showSearch
              optionFilterProp="label"
              value={selectedLogistic || "All Logistic"}
              onChange={(value) => {
                setSelectedLogistic(value);
              }}
              options={getLogisticListFilters(logisticList)}
              className="filter-select"
              style={{
                width: "100%",
                marginTop: 6,
              }}
              size="large"
            />
          </Col>
          <Col span={24}>
            <Text style={{ fontWeight: 600, color: "#232A36" }}>
              Tracking ID
            </Text>
            <Input
              placeholder="Tracking ID"
              value={trackingId}
              onChange={(e) => setTrackingId(e.target.value)}
              style={{
                width: "100%",
                marginTop: 6,
                borderRadius: 8,
              }}
              size="large"
            />
          </Col>
        </Row>
        <Row justify="end" style={{ marginTop: 32 }}>
          <Space size={16}>
            <Button
              size="large"
              onClick={resetState}
              style={{
                borderRadius: 8,
                fontWeight: 700,
                border: "1px solid #D9D9D9",
                background: "#fff",
              }}
            >
              Close
            </Button>
            <Button
              type="primary"
              size="large"
              style={{
                borderRadius: 8,
                fontWeight: 700,
                background: "#23235F",
                color: "#fff",
              }}
              loading={isLoading}
              onClick={handleAddLogistic}
            >
              {KitDetail?.assignedLogistic?._id || KitDetail?.trackingId
                ? "Edit Logistic"
                : "Add Logistic"}
            </Button>
          </Space>
        </Row>
      </div>
    </Modal>
  );
}

export default AssignLogisticToKit;
